import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const SupplierListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const OuterWrapper = styled.div`
  padding: 1rem;
`;

export const Title = styled.h2`
  width: 100%;
  text-align: center;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0 0 30px 0;
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  gap: ${(props) => props.padding ?? "0px"};
`;

export const BreadCrumb = styled.h2`
  color: #767676;
  font-size: 12px;
  font-family: lato;
  text-transform: initial;
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  margin-bottom: 10px;
`;
